import React, { useState } from 'react';

import './App.css';

import casos from './components/data/casos';
import { Dialog } from './components/Dialog';
import { Game } from './components/Game';

function App() {
  const [c, setC] = useState(0);
  const ultimo = casos.length-1;
  
  const avanzarEj = (e) => {
    if(c === (ultimo)){
      setC(0);
      showDialog();
      //…“es sentirme parte de un espacio donde convivo con familiares  que me aman, respetan, cuidan y son solidarios conmigo.
    }else{
        setC(c+1);
    }
    const chars = document.getElementsByClassName('ddcontainer');
      for (let item in chars) {
        if(typeof chars[item] === 'object'){
          chars[item].style.display='inherit';
          chars[item].style.visibility='visible';
        }
      }
  }

  const [dialog, setDialog] = useState({text:'Has llegado al final de la actividad, ¿deseas realizarla nuevamente?', type:'', open:false});
  
  const showDialog =(txt, type='success' )=>{
    setDialog({...dialog, open:true});
  }

  const closeDialog=(e) =>{
          setDialog({...dialog, open:false})
  }


  return (
    <div className="App">
        <Game 
          ejercicio={casos[c]} 
          c={casos[c]?.id} 
          totalCasos={casos.length} 
          avanzarEj={avanzarEj}  
        /> 
        {(dialog.open)&&<Dialog mensaje={dialog.text} type={dialog.type} closeDialog={closeDialog}/>}
        
    </div>
  );
}

export default App;
